import { Component } from 'preact'
import WidgetPreview from '../components/widget-preview';
import { LinkFilter } from '../components/filters';
import { __ } from '../../locales'

class ReviewBadge extends Component {
    state = {
        selectedLayout: 'horizontal',
    };
    render(props, state) {
        return (
            <WidgetPreview
                {...props}
                name={__('widget.review_badge.name')}
                type={'review-badge'}
                extraParams={[
                    'slugs',
                    'linkUrl'
                ]}
                layoutType={state.selectedLayout}
                badgeTitle={__('widget.type.badge')}
                badgeColor={'#00897D'}
                badgeFontColor={'#FFFFFF'}
            >
                <div className={'filters-wrapper mt-5 mb-5'}>
                    <LinkFilter
                        {...props}
                        hidden={props.inputs?.profileType === 'specialist' && props.selectedProfiles?.length <= 1}
                    />
                </div>
            </WidgetPreview>
        );
    }
}

export default ReviewBadge
